import React from "react";
import Header from "../../components/HeaderNavy";
import Footer from "../../components/FooterNavy";
import PromotersBanner from "../../components/PromotersBanner";
import RecentProjects from "../../components/Home/RecentProjects";
import ContactSection from "../../components/ContactSection";
import PremiumLifestyle from "../../components/Promoters/PremiumLifestyle";
import Transformativedevelopment from "../../components/Promoters/Transformativedevelopment";

function Home() {
  return (
    <>
      <Header />
      <PromotersBanner />
      <PremiumLifestyle />
      <Transformativedevelopment />
      {/* <RecentProjects /> */}
      <ContactSection />
      <Footer /> 
    </>
  );
}

export default Home;
